<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        2021年度河北省科学技术进步奖拟提名项目“渤海超大型船舶全过程智慧航行与靠离泊关键技术研究及应用”公示
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
      <div class="div-text-left news-Regular-14b6">
        <span>2021-05-21</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
      </div>
      <div class="div-line  divcss5"></div>
      <div class="div-row div-bottom10">
        <p class="indentation">
          根据河北省科技厅《关于2021年度河北省科学技术奖提名工作的通知》（冀科奖字〔2021〕1号）文件要求，现将我所作为第五完成单位拟提名2021年度河北省科学技术进步奖的项目“渤海超大型船舶全过程智慧航行与靠离泊关键技术研究及应用”有关内容进行公示，公示材料见附件。
        </p>
        <p class="indentation">
          公示时间：2021年5月21日至2021年5月27日。
        </p>
        <p class="indentation">
         公示期内，任何单位和个人若对公示项目有异议，请实名以书面形式向我单位提出，并提供必要的证明材料。
        </p>
        <p class="indentation">
         通讯地址：辽宁省大连市高新区黄浦路523号海事科技大厦A座1101室  大连海大智龙科技有限公司
        </p>
              <p class="indentation">
        <a href="javascript:void(0);" style="text-align:left;"
                  @click="popUp('new24_url')">点击下载附件</a>
                </p>
        <p class="indentation" style="text-align:right;">
          大连海大智龙科技有限公司<br/>
          2021年5月21日
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    methods: {
      popUp(winURL) {


        const {
          href
        } = this.$router.resolve({
          // eslint-disable-next-line indent
          name: 'pdf',
          query: {
            winURL: 'http://oss.zlonmarine.com/OnlineProduct/img-210524130022.pdf' 
          }
        })
        window.open(href)
      },
    },
  };

</script>

<style scoped>
  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }



  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2021/news24.vue